import { useSelector } from "react-redux";

const useEvents = () => {
    const events = useSelector((state) => state.events);
    return events;
};

export default useEvents;